var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "660 483 14.626 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #868686;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "password",
    transform: "translate(859 579)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-1",
    d: "M7.287,11.965a1.794,1.794,0,0,0-1.2,3.106v.991a1.225,1.225,0,1,0,2.449,0v-.991a1.794,1.794,0,0,0-1.251-3.106Zm.569,2.552a.431.431,0,0,0-.179.351v1.193a.363.363,0,0,1-.726,0V14.869a.431.431,0,0,0-.181-.351A.941.941,0,0,1,7.3,12.827h.015a.933.933,0,0,1,.543,1.691Z",
    transform: "translate(-199 -96)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-1",
    d: "M14.626,9.9A1.723,1.723,0,0,0,12.9,8.174V5.59a5.59,5.59,0,1,0-11.179,0V8.174A1.723,1.723,0,0,0,0,9.9v8.379A1.723,1.723,0,0,0,1.723,20H12.9a1.723,1.723,0,0,0,1.723-1.723ZM2.574,5.579a4.728,4.728,0,0,1,9.456,0V8.164H2.574ZM13.753,18.288a.862.862,0,0,1-.862.862H1.712a.862.862,0,0,1-.862-.862V9.9a.862.862,0,0,1,.862-.862H12.892a.862.862,0,0,1,.862.862Z",
    transform: "translate(-199 -96)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyPassword);
export default __webpack_public_path__ + "static/media/company_password.373466f61be032e2a9ef945955ba473e.svg";
export { ForwardRef as ReactComponent };